import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function FarmMegaMenuSidebar({
  macroCategories,
  activeMacroId,
  onSelectMacro,
  labelForMacro
}) {
  return (
    <aside className="w-[30%] min-w-[280px] border-r border-gray-200 dark:border-neutral-800 bg-gray-50 dark:bg-neutral-900 p-3.5">
      <ul className="space-y-1.5">
        {macroCategories.map((macro) => {
          const active = macro.id === activeMacroId;
          const macroLabel = labelForMacro(macro);

          return (
            <li key={macro.id}>
              <button
                type="button"
                onMouseEnter={() => onSelectMacro(macro.id)}
                onFocus={() => onSelectMacro(macro.id)}
                onClick={() => onSelectMacro(macro.id)}
                className={`group w-full px-3 py-2.5 rounded-md text-left transition flex items-center justify-between ${
                  active
                    ? 'bg-transparent text-gray-900 dark:text-gray-100'
                    : 'bg-transparent text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100'
                }`}
                aria-current={active ? 'true' : undefined}
              >
                <span className={`text-sm leading-tight ${active ? 'font-semibold' : 'font-medium'}`}>{macroLabel}</span>
                <ChevronRight
                  className={`w-4 h-4 transition ${
                    active
                      ? 'opacity-100 text-gray-500 dark:text-gray-400'
                      : 'opacity-0 group-hover:opacity-70 text-gray-400 dark:text-gray-500'
                  }`}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
